export default __webpack_public_path__ + "static/media/ACOMPIO.6c10a50b.png";